<template>
    <header class="row OTheader">
        <div class="col-xs-6 OTheaderleft">
          <a href="" class="logo"></a>
        </div>
        <div class="col-xs-6">
            <a class="OTbuttonNocontainer OTmenuLogout" @click="logout">Logout</a>
        </div>
    </header>

</template>

<script>

import axios from 'axios';

export default {
    methods: {
        logout() {
            axios.post('/otif-dashboard-api/api/v1/authenticate/logout')
            .then((res) => {
                this.$socket.disconnect();
                this.$store.dispatch('LOGOUT');
                location.reload(true);
            })
            .catch((err) => {
                this.$store.dispatch('LOGOUT');
                location.reload(true);
            });
        }
    }
}
</script>
